import React, { useState, useEffect } from 'react';
import { Eye } from 'lucide-react';
import { Button } from './ui/button';
import axios from 'axios';
import { API_BASE } from '../config/api';

const ImpersonationBanner = () => {
  const [info, setInfo] = useState(null);

  useEffect(() => {
    const raw = localStorage.getItem('impersonating');
    if (raw) {
      try { setInfo(JSON.parse(raw)); } catch {}
    }
    const handler = () => {
      const r = localStorage.getItem('impersonating');
      setInfo(r ? JSON.parse(r) : null);
    };
    window.addEventListener('storage', handler);
    return () => window.removeEventListener('storage', handler);
  }, []);

  if (!info) return null;

  const returnToAdmin = async () => {
    try {
      await axios.post(`${API_BASE}/admin/stop-impersonation`, {}, { withCredentials: true });
    } catch {}
    localStorage.removeItem('impersonating');
    window.location.href = '/admin';
  };

  return (
    <div className="fixed top-0 left-0 right-0 z-[9999] bg-amber-500 text-amber-950 px-4 py-2" data-testid="impersonation-banner">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="flex items-center gap-2 text-sm font-medium">
          <Eye className="w-4 h-4" />
          <span>Viewing as <strong>{info.name}</strong> ({info.email})</span>
        </div>
        <Button
          size="sm"
          variant="outline"
          className="bg-amber-600 border-amber-700 text-white hover:bg-amber-700 h-7 text-xs"
          onClick={returnToAdmin}
          data-testid="return-to-admin-btn"
        >
          Return to Admin
        </Button>
      </div>
    </div>
  );
};

export default ImpersonationBanner;
